import React, { Component } from 'react';
import { Link } from 'react-router-dom';

// ========== PARTS ==========
import NavBar from '../parts/NavBar';
import Footer from '../parts/Footer';
import Directory from '../parts/Directory';

// ========== ELEMENTS ==========
import Loader from '../elements/Loader';

// ========== SCSS ==========
import '../scss/directory.scss';

export class DirectoryView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      element: null
    };
  }

  async getDirectory(directoryId) {
    let response = await window.doRequest('GET', {
      action: 'getDirectoryContent',
      id: directoryId,
      token: sessionStorage.getItem('token')
    });

    if (response.status) {

      this.setState({
        loading: false,
        element: <Directory
                    id={directoryId}
                    name={response.content.info.name}
                    type={response.content.info.type}
                    parent_directory={response.content.info.parent_directory}
                    directory_list={response.content.directory_list.sort(window.alph)}
                    file_list={response.content.file_list.sort(window.alph)}
                    privileges={response.content.info.privileges}
                    history={this.props.history}
                  />
      })

    } else {
      window.alert(response.message);
    }
  }

  componentDidMount() {
    window.verifyIfIsLogged();

    let url = window.location;
    let directoryId = /[^/]*$/.exec(url)[0];

    if (directoryId != undefined && directoryId != null)
      this.getDirectory(directoryId);
    else
      this.props.history.push('/states');
  }

  render() {
    return (
      <main>
        <NavBar />
        <section id="directory_view">
          <div className="container">
            {
              (this.state.loading)
                ? <Loader />
                : this.state.element
            }
          </div>
        </section>
        <Footer />
      </main>
    );
  }
}

export default DirectoryView
